// extracted by mini-css-extract-plugin
export var closed = "_ay-1";
export var resizer = "_ay-0";